import React from 'react';
import { FaCloud } from 'react-icons/fa';

const GoogleBadges = () => {
  return (
    <div className="flex flex-col items-center justify-center mb-8 py-6 border-b border-gray-700">
      <p className="text-sm text-gray-400 mb-4">Powered by Google Cloud and Supported by Google for Startups</p>
      <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
        {/* Google Cloud Logo + Label */}
        <div className="flex items-center gap-3" aria-label="Powered by Google Cloud">
          <img
            src="https://www.gstatic.com/devrel-devsite/prod/v3d465e4c3bd2997841afa014a0e6a68e5ba35e9e98293c94a1a14dbe19b5b69d/cloud/images/social-icon-google-cloud-1200-630.png"
            alt="Google Cloud logo"
            className="h-6 md:h-7 w-auto rounded-sm object-contain"
            loading="lazy"
          />
          <span className="text-white font-medium">Google Cloud</span>
        </div>

        {/* Divider on larger screens */}
        <div className="hidden md:block h-6 w-px bg-gray-600" />

        {/* Google for Startups Logo + Label */}
        <div className="flex items-center gap-3" aria-label="Supported by Google for Startups">
          <img
            src="https://storage.googleapis.com/gweb-cloudblog-publish/images/startup_summit_2024.max-2500x2500.jpg"
            alt="Google for Startups logo"
            className="h-6 md:h-7 w-auto rounded-sm object-contain"
            loading="lazy"
          />
          <span className="text-white font-medium">Google for Startups</span>
        </div>
      </div>
    </div>
  );
};

export default GoogleBadges;
